<div class="app-footer d-flex align-items-center justify-content-between">
  <span class="m-auto copyright">Copyright All Rights Reserved Aladdin Companies © {{currentYear}} </span>
  <div class="float-right mx-3">Version: {{appVersion}}</div><br>
</div>


// WEBPACK FOOTER //
// ./src/app/core/components/footer/footer.component.html